// App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import handleBodyBackground from './utils/handleBodyBackground.jsx';
import ProtectedRoutes from './ProtectedRoutes.jsx';
import "./styles/index.css";

/* Here are the public routes */
import HomePage from './pages/PublicRoutes/HomePage.jsx';
import CategoriesPage from './pages/PublicRoutes/CategoriesPage.jsx';

/* Here are the authentication routes */
import LoginPage from './pages/AuthRoutes/LoginPage.jsx';
import RegisterPage from './pages/AuthRoutes/RegisterPage.jsx';

/* Here are the private routes */
import ProfilPage from './pages/PrivateRoutes/ProfilPage.jsx';
import TraderPage from './pages/PrivateRoutes/Trader/TraderPage.jsx';
import OffersPage from './pages/PrivateRoutes/Trader/OffersPage.jsx';
import ManagerPage from './pages/PrivateRoutes/Admin/ManagerPage.jsx';
import MerchantPage from './pages/PublicRoutes/MerchantPage.jsx';
import AboutPage from './pages/PublicRoutes/AboutPage.jsx';
import PassPage from './pages/PrivateRoutes/PassPage.jsx';

const sections = {
    client: [
        { path: "profil", element: <ProfilPage /> },
        { path: "*", element: <Navigate to="/" replace /> },
    ],
    trader: [
        { path: "", element: <TraderPage /> },
        { path: "profil", element: <ProfilPage /> },
        { path: "offers", element: <OffersPage /> },
        { path: "pass", element: < PassPage /> },
        { path: "*", element: <Navigate to="/trader" replace /> },
    ],
    admin: [
        { path: "", element: <ManagerPage /> },
        { path: "profil", element: <ProfilPage /> },
        { path: "*", element: <Navigate to="/admin" replace /> },
    ],
};

function RoleSection({ routes }) {
    return (
        <Routes>
            {routes.map((r) =>
                r.path
                ? <Route key={r.path} path={r.path} element={r.element} />
                : <Route key="index" index element={r.element} />
            )}
        </Routes>
    );
}

function AppRoutes() {
    const location = useLocation();
    handleBodyBackground(location);

    return (
        <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/restaurants' element={<CategoriesPage index='restaurants'/>} />
            <Route path='/activities' element={<CategoriesPage index='activity'/>} />
            <Route path='/beauty' element={<CategoriesPage index='beauty'/>} />
            <Route path='/cars' element={<CategoriesPage index='cars'/>} />
            <Route path='/alimentation' element={<CategoriesPage index='alimentation'/>} />
            <Route path='/about' element={<AboutPage />} />

            <Route path='/test' element={<ManagerPage />} />
            <Route path="/merchant/:id" element={<MerchantPage />} />


            <Route path='/login' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
 
            {Object.keys(sections).map((role) => (
                <Route key={role} element={<ProtectedRoutes allowedRoles={[role]} />}>
                <Route path={`/${role}/*`} element={<RoleSection routes={sections[role]} />} />
                </Route>
            ))}
            <Route path='*' element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <Router>
            <AppRoutes />
        </Router>
    );
}